import { axiosCms } from 'Axios.js';
import { authToken } from 'store/utility';
import * as actionTypes from 'store/actions/actionTypes';

export const getSettings = () => {
  return dispatch => {
    const URI = '/setting';
    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    axiosCms
      .get(URI)
      .then(response => {
        const { data } = response;

        dispatch({
          type: actionTypes.GET_SETTINGS,
          payload: data.settings,
        });
      })
      .catch(err => {
        console.error(`getSettings err: `, err);
      });
  };
};

export const updateSettings = (settings, successCallback) => dispatch => {
  const URI = '/setting';
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

  axiosCms
    .post(URI, settings)
    .then(response => {
      const { data } = response;

      dispatch({
        type: actionTypes.GET_SETTINGS,
        payload: data.settings,
      });

      if (successCallback) {
        successCallback();
      }
    })
    .catch(err => {
      console.error(`updateSettings err: `, err);
    });

  dispatch({
    type: actionTypes.SYNC_SETTING_QRCODE,
    settings: settings,
  });
};



// WEBPACK FOOTER //
// ./src/store/actions/setting.js